import axios from "axios";

// 환경에 따른 베이스 URL 설정 (Admin 전용)
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://mallang-pocket.cloud/app/admin/api/v2"
    : "http://localhost:6062/app/admin/api/v2";

/**
 * 일반 API용 axios 인스턴스 (BASE_URL 사용)
 */
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * 인증 전용 axios 인스턴스 (AUTH_URL 사용)
 */
export const authInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 요청 인터셉터: localStorage에서 access_token을 읽어 Header에 추가
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("mallang_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 응답 인터셉터: 401 에러(토큰 만료) 발생 시 처리
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("mallang_refresh_token");

      if (refreshToken) {
        try {
          // 리프레시 토큰으로 새로운 액세스 토큰 요청 (AUTH_URL 사용)
          const res = await axios.post(`${BASE_URL}/refresh`, {
            refresh_token: refreshToken,
          });

          if (res.status === 200 || res.status === 201) {
            const { access_token, refresh_token } = res.data;

            localStorage.setItem("mallang_access_token", access_token);
            if (refresh_token) {
              localStorage.setItem("mallang_refresh_token", refresh_token);
            }

            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            return api(originalRequest);
          }
        } catch (refreshError) {
          // console.error("Token refresh failed:", refreshError);
          handleLogout();
        }
      } else {
        handleLogout();
      }
    }
    return Promise.reject(error);
  },
);

/**
 * 로그아웃 처리 및 페이지 이동
 */
const handleLogout = () => {
  localStorage.removeItem("mallang_access_token");
  localStorage.removeItem("mallang_refresh_token");
  localStorage.removeItem("mallang_user");
  window.location.href = "/";
};

export default api;
